var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.214,
    height: 22,
    viewBox: "0 0 21.214 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "doctor-icon",
    d: "M23.714,16.26a3.093,3.093,0,1,0-4.058,2.971A4.469,4.469,0,0,1,10.9,18V16.82a1.553,1.553,0,0,0,.28-.212l5.017-5,.152-.154a4.625,4.625,0,0,0-.893-7.291,2.289,2.289,0,1,0-2.276,2.488,2.274,2.274,0,0,0,1.808-.909,3.067,3.067,0,0,1,.249,4.6l-5.12,5.1L5.146,10.5l-.16-.156a3.082,3.082,0,0,1,0-4.382,3.155,3.155,0,0,1,.266-.226,2.273,2.273,0,0,0,1.806.907,2.32,2.32,0,1,0-2.277-2.48,4.7,4.7,0,0,0-.9.685,4.651,4.651,0,0,0,0,6.619l5.173,5.149a1.538,1.538,0,0,0,.273.21V18a6.039,6.039,0,0,0,11.92,1.339,3.137,3.137,0,0,0,2.463-3.078Z",
    transform: "translate(-2.5 -2)",
    fill: "#7aba56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon);
export default __webpack_public_path__ + "static/media/doctor-icon.d5ca2e9aa61fd874eaab21e82082b2ef.svg";
export { ForwardRef as ReactComponent };